module.exports = __webpack_public_path__ + "img/img20.a7da954f.svg";